import { routes } from '../../../constants/config';
import { selectedItemsSelector } from '../../../selectors';
import { bulkActionsSubmit } from './bulk_core';

/**
 * Archive selcted item/s (in bulk)
 */
export const bulkActionsArchive = () => (dispatch, getState) =>
  dispatch(
    bulkActionsSubmit({
      name: 'archive',
      route: routes.BULK_ARCHIVE,
      data: {
        archivables: selectedItemsSelector(getState()),
      },
    }),
  );

export const bulkActionsRestore = () => (dispatch, getState) =>
  dispatch(
    bulkActionsSubmit({
      name: 'restore',
      route: routes.BULK_RESTORE,
      data: {
        archivables: selectedItemsSelector(getState()),
      },
    }),
  );
